import * as React from 'react';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import Logo from '../../assets/real-sign.svg';
import styles from './publicNav.styles';

type LinkDef = { label: string, to?: string, href?: string };

type Props = {
  classes: Object,
  centerLinks?: Array<LinkDef>,
  actions?: React.Node,
};

const defaultCenterLinks: Array<LinkDef> = [
  { label: 'Verify a signature', to: '/s' },
  { label: 'Log in', to: '/login' },
];

const PublicNavC = ({ classes, centerLinks, actions }: Props) => {
  const links = centerLinks !== undefined ? centerLinks : defaultCenterLinks;
  return (
    <header className={classes.nav}>
      <div className={classes.navInner}>
        <Link to="/welcome" className={classes.logoWrap} aria-label="Home">
          <Logo />
        </Link>
        <nav className={classes.navLinks}>
          {links.map(({ label, to, href }) =>
            to ? (
              <Link key={label} to={to} className={classes.navLink}>{label}</Link>
            ) : (
              <a key={label} href={href} className={classes.navLink}>{label}</a>
            )
          )}
        </nav>
        {actions && (
          <div className={classes.navActions}>{actions}</div>
        )}
      </div>
    </header>
  );
};

PublicNavC.defaultProps = {
  centerLinks: undefined,
  actions: null,
};

export default withStyles(styles)(PublicNavC);
